var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "plans-wrapper" },
    [
      _c("div", { staticClass: "intro-wrapper" }, [
        _c(
          "div",
          { staticClass: "period-switch-container m-auto text-center" },
          [
            _c("h1", { staticClass: "header font-outfit-bold text-center" }, [
              _vm._v(
                " " +
                  _vm._s(
                    _vm.$t("pages.pricing.simpleAndAffordablePricePlans")
                  ) +
                  " "
              ),
            ]),
            _c("p", { staticClass: "subheader font-outfit-light mt-0" }, [
              _vm._v(
                " " +
                  _vm._s(
                    _vm.$t(
                      "pages.pricing.allPlansComeWithA15DayMoneyBackGuarantee"
                    )
                  ) +
                  " "
              ),
            ]),
            _c(
              "div",
              { staticClass: "switch-wrapper mx-auto position-relative" },
              [
                _c("form-switcher", {
                  attrs: {
                    size: "md",
                    variant: "blue",
                    disabled: _vm.loading,
                    options: _vm.periodOptions,
                  },
                  model: {
                    value: _vm.period,
                    callback: function ($$v) {
                      _vm.period = $$v
                    },
                    expression: "period",
                  },
                }),
                _c(
                  "div",
                  {
                    staticClass:
                      "arrow-text d-flex font-tragic-marker align-items-start",
                    class: _vm.arrowTextClass,
                  },
                  [
                    _c(
                      "svg",
                      {
                        attrs: {
                          width: "40",
                          height: "29",
                          viewBox: "0 0 40 29",
                          fill: "none",
                          xmlns: "http://www.w3.org/2000/svg",
                          "svg-inline": "",
                          role: "presentation",
                          focusable: "false",
                          tabindex: "-1",
                        },
                      },
                      [
                        _c("path", {
                          attrs: {
                            d: "M17.578 5.489c.085.375.06.768-.071 1.13-.21.602-.727.71-1.253.355-.254-.17-.51-.367-.796-.456-1.46-.452-2.937-.872-4.403-1.31-1.897-.573-3.804-1.114-5.802-1.216-.159-.007-.318.003-.516.005.054.128.072.188.102.241 3.205 5.46 7.02 10.426 11.784 14.62 3.197 2.812 6.757 4.953 10.957 5.916 2.096.482 4.199.794 6.355.477 1.083-.159 1.997-.589 2.735-1.44.33-.368.74-.654 1.2-.832.73-.28 1.2-.053 1.484.673.21.544.303 1.137.453 1.702.083.308-.02.516-.258.723a9.616 9.616 0 01-3.428 1.929c-2.35.739-4.712.628-7.074.084-4.756-1.095-8.838-3.491-12.568-6.55-4.05-3.322-7.432-7.257-10.427-11.54l-.684-.971a.733.733 0 00-.023.464c.231.87.411 1.756.716 2.6a353.125 353.125 0 002.626 6.917c.305.786.061 1.52-.13 2.262-.044.175-.221.317-.381.534-.225-.24-.384-.41-.534-.585-1.481-1.727-2.368-3.77-3.084-5.897-.92-2.749-1.646-5.566-2.877-8.207a16.235 16.235 0 01-.953-2.521 9.538 9.538 0 01-.37-2.42C.35 1.235.942.679 1.878.519c.245-.038.492-.06.74-.067 2.296-.076 4.479.5 6.653 1.136 2.42.707 4.845 1.393 7.264 2.098.122.036.279.109.329.21.262.517.556 1.036.713 1.593z",
                            fill: "currentColor",
                          },
                        }),
                      ]
                    ),
                    _c("p", [_vm._v(_vm._s(_vm.arrowText))]),
                  ]
                ),
              ],
              1
            ),
          ]
        ),
      ]),
      _c(
        "div",
        { staticClass: "cards-wrapper text-center mt-lg-0" },
        [
          _c(
            "el-row",
            {
              staticClass:
                "cards-container d-flex flex-wrap m-auto text-center justify-content-center",
              attrs: { gutter: 40 },
            },
            [
              _vm._l(_vm.plans, function (plan) {
                return _c(
                  "el-col",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: plan.show,
                        expression: "plan.show",
                      },
                    ],
                    key: plan.title,
                    staticClass: "mb-lg-0",
                    class: { "mt-md-3 mt-lg-0": !plan.popular },
                    attrs: { md: 8 },
                  },
                  [
                    _c("plan-card", {
                      staticClass: "plan-card mb-md-0",
                      attrs: {
                        title: plan.title,
                        plan: _vm.getPlan(plan.slug),
                        popular: plan.popular,
                        description: plan.description,
                        price: _vm.getPlan(plan.slug)
                          ? _vm.getPlan(plan.slug).price
                          : null,
                        "monthly-price": _vm.getMonthlyPrice(plan.slug),
                        "currency-symbol": _vm.getPlan(plan.slug)
                          ? _vm.getPlan(plan.slug).currency
                          : null,
                        period: _vm.period,
                        options: _vm.plansOptions,
                        loading: _vm.loading,
                        "button-loading": plan.slug === _vm.loadingPlanSlug,
                        "disabled-features": plan.disabledFeatures,
                      },
                      on: {
                        "choose-plan": (value) =>
                          _vm.onChoosePlan(plan.slug, value),
                        contact: _vm.onContact,
                      },
                      model: {
                        value: _vm.cardValues[_vm.period][plan.slug],
                        callback: function ($$v) {
                          _vm.$set(_vm.cardValues[_vm.period], plan.slug, $$v)
                        },
                        expression: "cardValues[period][plan.slug]",
                      },
                    }),
                  ],
                  1
                )
              }),
              _c(
                "el-col",
                { staticClass: "mb-lg-0 mt-md-3 mt-lg-0", attrs: { md: 8 } },
                [
                  _c("white-label-card", {
                    staticClass: "plan-card mb-md-0",
                    attrs: { period: _vm.period },
                    on: { contact: _vm.onWhiteLabelContact },
                  }),
                ],
                1
              ),
            ],
            2
          ),
          _c("p", { staticClass: "prices-info" }, [
            _vm._v(
              " " +
                _vm._s(
                  _vm.$t(
                    "pages.pricing.pricesMayBeSubjectToAdditionalVatDependingOnYourCountry"
                  )
                ) +
                " 👆 "
            ),
          ]),
        ],
        1
      ),
      _c("dialog-enterprise", {
        attrs: {
          "enterprise-visible": _vm.dialogEnterpriseVisible,
          type: _vm.contactType,
        },
        on: {
          "close-enterprise": function ($event) {
            _vm.dialogEnterpriseVisible = false
          },
        },
      }),
      _c("dialog-confirm", {
        ref: "dialogConfirm",
        attrs: {
          visible: _vm.dialogConfirm,
          "preview-data": _vm.previewData,
          record: _vm.chosenData,
        },
        on: {
          "close-dialog": function ($event) {
            _vm.dialogConfirm = false
          },
          "confirm-dialog": _vm.confirmedUpdatePlan,
        },
      }),
      _c("dialog-thank-you", {
        attrs: {
          "dialog-thank-you-visible": _vm.dialogThankYouVisible,
          "thank-you-data": _vm.chosenData,
        },
        on: { "close-dialog": _vm.closeDialog },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }